// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__OK4LH","inner":"Footer_inner__AZ-C9","nextIcon":"Footer_nextIcon__2UcNB","innerLeft":"Footer_innerLeft__3_rPP"};